<!-- eslint-disable -->
<template>
  <div id="app">
    <div id="top"></div>
    <!-- Header Section -->
    <header class="header" :class="{ 'mobile-menu-open': mobileMenuOpen }">
      <div class="header-container">
        <div class="logo">
          <img
            :src="headerLogo"
            alt="VIDA Living logo"
            class="logo-image"
          />
          <span class="logo-text">LIVING</span>
        </div>

        <!-- Desktop Navigation, Language Switcher and Hamburger -->
        <div class="header-right-section">
          <nav class="desktop-nav">
            <a href="#kitchen" class="nav-link" @click.prevent="smoothScrollTo('#kitchen')">{{ t.nav.kitchen }}</a>
            <a href="#living" class="nav-link" @click.prevent="smoothScrollTo('#living')">{{ t.nav.living }}</a>
            <a href="#dining" class="nav-link" @click.prevent="smoothScrollTo('#dining')">{{ t.nav.dining }}</a>
            <a href="#bedroom" class="nav-link" @click.prevent="smoothScrollTo('#bedroom')">{{ t.nav.bedroom }}</a>
          </nav>
          
          <div class="header-actions">
            <div
              class="language-switcher"
              ref="languageSwitcher"
            >
              <button
                class="lang-current-btn"
                @click.stop="toggleLanguageDropdown"
                :aria-label="`Current language: ${languageLabel}`"
              >
                <span class="lang-current-label">{{ languageLabel }}</span>
                <span class="lang-current-icon" :class="{ open: languageDropdownOpen }">▾</span>
              </button>
              <transition name="fade">
                <ul
                  v-if="languageDropdownOpen"
                  class="lang-dropdown"
                >
                  <li>
                    <button
                      class="lang-dropdown-item"
                      :class="{ active: currentLanguage === 'en' }"
                      @click="handleLanguageSelect('en')"
                    >
                      EN
                    </button>
                  </li>
                  <li>
                    <button
                      class="lang-dropdown-item"
                      :class="{ current: currentLanguage === 'zh' }"
                      @click="handleLanguageSelect('zh')"
                    >
                      繁
                    </button>
                  </li>
                  <li>
                    <button
                      class="lang-dropdown-item"
                      :class="{ current: currentLanguage === 'cn' }"
                      @click="handleLanguageSelect('cn')"
                    >
                      简
                    </button>
                  </li>
                </ul>
              </transition>
            </div>

            <!-- Hamburger Button -->
            <button
              class="hamburger-btn"
              @click="toggleMobileMenu"
              :class="{ active: mobileMenuOpen }"
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- Right Side Sliding Menu -->
    <div class="menu-overlay" v-if="mobileMenuOpen" @click="closeMobileMenu"></div>
    <nav class="side-menu" :class="{ open: mobileMenuOpen }">
      <div class="side-menu-content">
        <a href="#top" class="side-menu-link" @click.prevent="handleNavClick($event, '#top')">{{ t.nav.home }}</a>
        
        <!-- Expandable Product Menu -->
        <div class="side-menu-expandable">
          <button class="side-menu-expandable-header" @click="toggleProductMenu">
            <span>{{ t.nav.product }}</span>
            <span class="expandable-arrow" :class="{ expanded: productMenuExpanded }">›</span>
          </button>
          <div class="side-menu-submenu" :class="{ expanded: productMenuExpanded }">
            <a href="#kitchen" class="side-menu-link side-menu-sublink" @click.prevent="handleNavClick($event, '#kitchen')">{{ t.nav.kitchen }}</a>
            <a href="#living" class="side-menu-link side-menu-sublink" @click.prevent="handleNavClick($event, '#living')">{{ t.nav.living }}</a>
            <a href="#dining" class="side-menu-link side-menu-sublink" @click.prevent="handleNavClick($event, '#dining')">{{ t.nav.dining }}</a>
            <a href="#bedroom" class="side-menu-link side-menu-sublink" @click.prevent="handleNavClick($event, '#bedroom')">{{ t.nav.bedroom }}</a>
          </div>
        </div>
        <a href="#showroom" class="side-menu-link" @click.prevent="handleNavClick($event, '#showroom')">{{ t.nav.showroom }}</a>
        <a href="#partners" class="side-menu-link" @click.prevent="handleNavClick($event, '#partners')">{{ t.nav.partners }}</a>
        <a href="#news" class="side-menu-link" @click.prevent="handleNavClick($event, '#news')">{{ t.nav.news }}</a>
        <a href="#aboutUS" class="side-menu-link" @click.prevent="handleNavClick($event, '#aboutUS')">{{ t.nav.aboutUs }}</a>
        <a href="#contact" class="side-menu-link" @click.prevent="handleNavClick($event, '#contact')">{{ t.nav.contact }}</a>
        <!-- <div class="side-menu-language-switcher">
          <button 
            class="lang-btn" 
            :class="{ active: currentLanguage === 'en' }"
            @click="changeLanguage('en')"
          >
            EN
          </button>
          <span class="lang-separator">|</span>
          <button 
            class="lang-btn" 
            :class="{ active: currentLanguage === 'zh' }"
            @click="changeLanguage('zh')"
          >
            繁
          </button>
          <span class="lang-separator">|</span>
          <button 
            class="lang-btn" 
            :class="{ active: currentLanguage === 'cn' }"
            @click="changeLanguage('cn')"
          >
            简
          </button>
        </div>-->
      </div>
    </nav>

    <!-- Hero Section: Video Background (kept for HOME anchor) -->
    <section
      class="wardrobe-section"
      id="top"
      :class="{ 'video-theme-compact': !useFullVideoLayout }"
    >
      <div
        class="video-background"
        :class="{ 'video-background-compact': !useFullVideoLayout }"
      >
        <video
          autoplay
          muted
          loop
          playsinline
          class="background-video"
          :class="{ 'background-video-compact': !useFullVideoLayout }"
          :src="videoSrc"
        >
          Your browser does not support the video tag.
        </video>
        <div
          class="video-overlay"
          :class="{ 'video-overlay-compact': !useFullVideoLayout }"
        ></div>
      </div>

    </section>

    <!-- Kitchen Section: Banner and Image Grid -->
    <section class="kitchen-section" id="kitchen">
      <!-- Kitchen Banner -->
      <div class="kitchen-banner">
        <img :src="kitchenBanner" alt="VIDA KITCHEN" class="section-banner-image" />
      </div>

      <!-- Kitchen Image Grid -->
      <div class="kitchen-grid-section">
        <div class="kitchen-grid">
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 0)">
            <img v-if="kitchenImages[0]" :src="kitchenImages[0]" alt="Kitchen Image 1" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 1)">
            <img v-if="kitchenImages[1]" :src="kitchenImages[1]" alt="Kitchen Image 2" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 2)">
            <img v-if="kitchenImages[2]" :src="kitchenImages[2]" alt="Kitchen Image 3" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 3)">
            <img v-if="kitchenImages[3]" :src="kitchenImages[3]" alt="Kitchen Image 4" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 4)">
            <img v-if="kitchenImages[4]" :src="kitchenImages[4]" alt="Kitchen Image 5" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('kitchen', 5)">
            <img v-if="kitchenImages[5]" :src="kitchenImages[5]" alt="Kitchen Image 6" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>

        <!-- Living Section: Banner and Image Grid -->
        <section class="kitchen-section" id="living">
      <!-- Living Banner -->
      <div class="kitchen-banner">
        <img :src="livingBanner" alt="VIDA LIVING" class="section-banner-image" />
      </div>

      <!-- Living Image Grid -->
      <div class="kitchen-grid-section">
        <div class="kitchen-grid">
          <div class="kitchen-grid-item" @click="openImageDialog('living', 0)">
            <img v-if="livingImages[0]" :src="livingImages[0]" alt="Living Image 1" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('living', 1)">
            <img v-if="livingImages[1]" :src="livingImages[1]" alt="Living Image 2" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('living', 2)">
            <img v-if="livingImages[2]" :src="livingImages[2]" alt="Living Image 3" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('living', 3)">
            <img v-if="livingImages[3]" :src="livingImages[3]" alt="Living Image 4" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('living', 4)">
            <img v-if="livingImages[4]" :src="livingImages[4]" alt="Living Image 5" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('living', 5)">
            <img v-if="livingImages[5]" :src="livingImages[5]" alt="Living Image 6" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>

    
    <!-- Dining Section: Banner and Image Grid -->
    <section class="kitchen-section" id="dining">
      <!-- Dining Banner -->
      <div class="kitchen-banner">
        <img :src="diningBanner" alt="VIDA DINING" class="section-banner-image" loading="lazy"/>
      </div>

      <!-- Dining Image Grid -->
      <div class="kitchen-grid-section">
        <div class="kitchen-grid">
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 0)">
            <img v-if="diningImages[0]" :src="diningImages[0]" alt="Dining Image 1" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 1)">
            <img v-if="diningImages[1]" :src="diningImages[1]" alt="Dining Image 2" class="kitchen-image"loading="lazy" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 2)">
            <img v-if="diningImages[2]" :src="diningImages[2]" alt="Dining Image 3" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 3)">
            <img v-if="diningImages[3]" :src="diningImages[3]" alt="Dining Image 4" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 4)">
            <img v-if="diningImages[4]" :src="diningImages[4]" alt="Dining Image 5" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('dining', 5)">
            <img v-if="diningImages[5]" :src="diningImages[5]" alt="Dining Image 6" class="kitchen-image" loading="lazy" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- Bedroom Section: Banner and Image Grid -->
    <section class="kitchen-section" id="bedroom">
      <!-- Bedroom Banner -->
      <div class="kitchen-banner">
        <img :src="bedroomBanner" alt="VIDA BEDROOM" class="section-banner-image" loading="lazy"/>
      </div>

      <!-- Bedroom Image Grid -->
      <div class="kitchen-grid-section">
        <div class="kitchen-grid">
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 0)">
            <img v-if="bedroomImages[0]" :src="bedroomImages[0]" alt="Bedroom Image 1" class="kitchen-image" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 1)">
            <img v-if="bedroomImages[1]" :src="bedroomImages[1]" alt="Bedroom Image 2" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 2)">
            <img v-if="bedroomImages[2]" :src="bedroomImages[2]" alt="Bedroom Image 3" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 3)">
            <img v-if="bedroomImages[3]" :src="bedroomImages[3]" alt="Bedroom Image 4" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 4)">
            <img v-if="bedroomImages[4]" :src="bedroomImages[4]" alt="Bedroom Image 5" class="kitchen-image" loading="lazy"/>
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
          <div class="kitchen-grid-item" @click="openImageDialog('bedroom', 5)">
            <img v-if="bedroomImages[5]" :src="bedroomImages[5]" alt="Bedroom Image 6" class="kitchen-image" loading="lazy" />
            <div v-else class="kitchen-image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- VIDA Showroom Section -->
    <section class="showroom-section" id="showroom">
      <div class="showroom-hero">
        <img :src="require('@/assets/showroom/showroom.webp')" :alt="t.showroom.heroAlt" class="showroom-hero-image" loading="lazy"/>
        <div class="">
         <!--  <div class="showroom-hero-title">{{ t.showroom.title }}</div> -->
        </div>
      </div>

      <div class="showroom-intro">
      <p>
        <b v-html="t.showroom.name"></b>
        <br />
        <span v-if="t.showroom.intro">{{ t.showroom.intro }}</span>
        <span v-if="t.showroom.intro2"><br /><br />{{ t.showroom.intro2 }}</span>
        <span v-if="t.showroom.intro3"><br /><br />{{ t.showroom.intro3 }}</span>
      </p>
       </div>


      <div class="showroom-feature-card">
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/slidingdoor1.webp')" alt="showroom image 1" class="showroom-image"loading="lazy" />
        </div>
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/slidingdoor2.webp')" alt="showroom image 2" class="showroom-image"loading="lazy" />
        </div>
        <div class="showroom-feature-text">
          <h3 v-html="t.showroom.feature1.title"></h3>
          <p>
            <span v-if="t.showroom.feature1.description">{{ t.showroom.feature1.description }}</span>
            <span v-if="t.showroom.feature1.description2"><br /><br />{{ t.showroom.feature1.description2 }}</span>
            <span v-if="t.showroom.feature1.description3"><br /><br />{{ t.showroom.feature1.description3 }}</span>
          </p>
          <a href="#" class="showroom-read-more" v-if="t.showroom.feature1.readMore">
            {{ t.showroom.feature1.readMore }}
          </a>
        </div>
      </div>

      <div class="showroom-feature-card">
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom1.webp')" alt="showroom image 3" class="showroom-image" loading="lazy"/>
        </div>
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom2.webp')" alt="showroom image 4" class="showroom-image" loading="lazy"/>
        </div>
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom3.webp')" alt="showroom image 5" class="showroom-image" loading="lazy"/>
        </div>
      </div>
      
      <div class="showroom-feature-card">
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom4.webp')" alt="showroom image 6" class="showroom-image" loading="lazy" />
        </div>
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom5.webp')" alt="showroom image 7" class="showroom-image" loading="lazy"/>
        </div>
        <div class="showroom-feature-image">
          <img :src="require('@/assets/showroom/showroom6.webp')" alt="showroom image 8" class="showroom-image" loading="lazy" />
        </div>
      </div>
    </section>

    <!-- VIDA Partners Section -->
    <section class="partners-section" id="partners">
      <div class="partners-hero">
        <img :src="require('@/assets/partners/vidapartners.webp')" :alt="t.partners.heroAlt" class="partners-hero-image" loading="lazy" />
        <div class="">
          <!--<div class="partners-hero-title">{{ t.partners.title }}</div>-->
        </div>
      </div>

      <div class="partners-intro">
        <p>{{ t.partners.intro }}</p>
      </div>

      <div class="partners-content">
        <div
          class="partner-card"
          v-for="(partner, index) in t.partners.cards"
          :key="partner.name || index"
        >
          <div class="partner-logo">
            <img :src="partnerLogos[index]" :alt="partner.logoAlt || t.partners.logoAlt" loading="lazy" />
          </div>
          <div class="partner-text">
            <p class="partner-body">
              <b v-html="partner.name"></b>
              <br />
              <span v-if="partner.description">{{ partner.description }}</span>
              <span v-if="partner.description2"><br /><br />{{ partner.description2 }}</span>
              <span v-if="partner.description3"><br /><br />{{ partner.description3 }}</span>
              <span v-if="partner.description4"><br /><br />{{ partner.description4 }}</span>
              <span v-if="partner.description5"><br /><br />{{ partner.description5 }}</span>
              <span v-if="partner.description6"><br /><br />{{ partner.description6 }}</span>
              
            </p>
          </div>

          <div
            class="partner-separator"
            v-if="index < t.partners.cards.length - 1"
          ></div>
        </div>
      </div>
    </section>

    <!-- News Section -->
    <section class="news-section" id="news">
      <div class="news-container">
        <h2 class="news-title">{{ t.news.title }}</h2>
        
        <div class="news-main-content">
          <!-- Main Image -->
          <div class="news-main-image" @click="openImageDialog('news', 0)">
            <template v-if="newsImages[0]">
              <video
                v-if="isVideo(newsImages[0])"
                :src="newsImages[0]"
                class="news-image"
                autoplay
                muted
                loop
                playsinline
                preload="metadata"
              ></video>
              <img v-else :src="newsImages[0]" alt="News Main Media" class="news-image" loading="lazy"/>
            </template>
            <div v-else class="news-image-placeholder"></div>
          </div>
          
          <!-- Text Content -->
          <div class="news-text-content">
            <h3 class="news-headline">{{ t.news.headline }}</h3>
            <p class="news-paragraph">{{ t.news.paragraph }}</p>
            
            <div class="exhibition-details">
              <h4 class="exhibition-details-title">{{ t.news.exhibitionDetails }}</h4>
              <div class="exhibition-info">
                <div class="exhibition-item">
                  <span class="exhibition-label">{{ t.news.venue }}:</span>
                  <span class="exhibition-value">{{ t.news.venueName }}</span>
                </div>
                <div class="exhibition-item">
                  <span class="exhibition-label">{{ t.news.booth }}:</span>
                  <span class="exhibition-value">{{ t.news.boothNumber }}</span>
                </div>
                <div class="exhibition-item">
                  <span class="exhibition-label">{{ t.news.dateTime }}:</span>
                  <div class="exhibition-dates">
                    <div>{{ t.news.date1 }}</div>
                    <div>{{ t.news.date2 }}</div>
                    <div>{{ t.news.date3 }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Three Smaller Images -->
        <div class="news-gallery">
          <div class="news-gallery-item" @click="openImageDialog('news', 1)">
            <template v-if="newsImages[1]">
              <video
                v-if="isVideo(newsImages[1])"
                :src="newsImages[1]"
                class="news-image"
                muted
                loop
                playsinline
              ></video>
              <img v-else :src="newsImages[1]" alt="News Gallery Media 1" class="news-image" loading="lazy"/>
            </template>
            <div v-else class="news-image-placeholder"></div>
          </div>
          <div class="news-gallery-item" @click="openImageDialog('news', 2)">
            <template v-if="newsImages[2]">
              <video
                v-if="isVideo(newsImages[2])"
                :src="newsImages[2]"
                class="news-image"
                muted
                loop
                playsinline
              ></video>
              <img v-else :src="newsImages[2]" alt="News Gallery Media 2" class="news-image" loading="lazy"/>
            </template>
            <div v-else class="news-image-placeholder"></div>
          </div>
          <div class="news-gallery-item" @click="openImageDialog('news', 3)">
            <template v-if="newsImages[3]">
              <video
                v-if="isVideo(newsImages[3])"
                :src="newsImages[3]"
                class="news-image"
                muted
                loop
                playsinline
              ></video>
              <img v-else :src="newsImages[3]" alt="News Gallery Media 3" class="news-image"loading="lazy" />
            </template>
            <div v-else class="news-image-placeholder"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- About Us Section -->
    <section class="about-section" id="aboutUS">
      <!-- Storefront Image Banner -->
      <div class="storefront-banner">
        <div class="storefront-banner-container">
          <img :src="aboutUsBanner" alt="About Us Storefront" class="storefront-image" loading="lazy"/>
        </div>
      </div>

      <!-- Section A: Intro text aligned right -->
      <div class="about-content about-section-a">
        <div class="about-content-container">
          <div class="about-logo-column">
            <!--off set-->
          </div>
          <div class="about-text-column">
            <div class="about-paragraph-block">
              <p class="about-paragraph" v-html="t.about.paragraph1"></p>
              <p class="about-paragraph" v-html="t.about.paragraph2"></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Divider graphic -->
      <div class="timeline-graphics">
        <img :src="finestImage" alt="Finest and Finest Design Nest Timeline" class="finest-image" loading="lazy" />
      </div>

      <!-- Mobile Layout: Two Images with Captions -->
      <div class="about-mobile-images">
        <div class="about-mobile-image-item">
          <div class="about-mobile-image-wrapper">
            <img :src="finestMobileImage" alt="Finest storefront" class="about-mobile-image" loading="lazy" />
          </div>
          <p class="about-mobile-caption">{{ t.about.finestCaption }}</p>
        </div>
        <div class="about-mobile-image-item">
          <div class="about-mobile-image-wrapper">
            <img :src="designNestMobileImage" alt="Finest Design Nest interior" class="about-mobile-image"loading="lazy" />
          </div>
          <p class="about-mobile-caption">{{ t.about.designNestCaption }}</p>
        </div>
        <!-- Mobile Paragraphs 3 and 4 -->
        <div class="about-mobile-paragraphs">
          <div class="about-paragraph-block">
            <p class="about-paragraph" v-html="t.about.paragraph3"></p>
          </div>
          <div class="about-paragraph-block">
            <p class="about-paragraph" v-html="t.about.paragraph4"></p>
          </div>
        </div>
      </div>

      <!-- Section B: Logo left, text right -->
      <div class="about-split">
        <div class="about-logo-column">
          <img :src="vidaLogo" alt="VIDA European Living" class="vida-logo-image" loading="lazy"/>
        </div>
        <div class="about-text-column align-right">
          <div class="about-paragraph-block">
            <p class="about-paragraph" v-html="t.about.paragraph3"></p>
          </div>
          <div class="about-paragraph-block">
            <p class="about-paragraph" v-html="t.about.paragraph4"></p>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section" id="contact" ref="contactSection">
      <div class="contact-container">
        <div class="contact-map">
          <a
            href="https://www.amap.com/search?id=B0L0FZ0MOG&city=810005&geoobj=113.970768%7C22.174797%7C114.578846%7C22.482725&query_type=IDQ&query=VIDA+LIVING&zoom=11.11"
            target="_blank"
            rel="noopener noreferrer"
            class="map-link"
          >
            <!-- English map -->
            <img
              v-if="currentLanguage === 'en'"
              :src="mapSources.en"
              alt="VIDA Living map (English)"
              class="map-image"
              loading="lazy"
              
            />
            <!-- Traditional Chinese map -->
            <img
              v-else-if="currentLanguage === 'zh'"
              :src="mapSources.zh"
              alt="VIDA Living 地圖（繁體）"
              class="map-image"
              loading="lazy"
            />
            <!-- Simplified Chinese map -->
            <img
              v-else
              :src="mapSources.cn"
              alt="VIDA Living 地图（简体）"
              class="map-image"
              loading="lazy"
            />
          </a>
        </div>
        <div class="contact-card">
          <div class="contact-accent"></div>
          <div class="contact-details">
            <div class="contact-title">
              <span class="contact-title-bold">{{ t.contact.title }}</span>
              <span class="contact-title-bold">{{ t.contact.subtitle }}</span>
            </div>
            <div class="contact-block">
              <p class="contact-heading">{{ t.contact.officeShowroom }}</p>
              <p class="contact-text" v-html="t.contact.address"></p>
            </div>
            <div class="contact-block">
              <div class="contact-info-grid contact-text">
                <strong>{{ t.contact.phone }}:</strong>
                <a href="tel:+85227411112" class="contact-link">+852 2741 1112</a>
                <strong>{{ t.contact.whatsapp }}:</strong>
                <a href="https://wa.me/85246342710" class="contact-link">+852 4634 2710</a>
                <strong>{{ t.contact.fax }}:</strong>
                <a href="tel:+85227411382" class="contact-link">+852 2741 1383</a>
                <strong>{{ t.contact.email }}:</strong>
                <a href="mailto:info@vidaliving.com.hk" class="contact-link">info@vidaliving.com.hk</a>
              </div><br/>
              <p class="contact-text">
                <a href="https://www.vidaliving.com" class="contact-link" target="_blank" rel="noopener">{{ t.contact.website }}</a>
              </p>
            </div>

            
            <div class="contact-block">
              <p class="contact-text" v-html="t.contact.addressChinese"></p>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="contact-card contact-form-card">
          <div class="contact-accent"></div>
          <div class="contact-details">
            <div class="contact-title">
              <span class="contact-title-bold">{{ t.contact.getInTouch }}</span>
            </div>
            <form
              class="contact-form"
              action="mailto:info@vidaliving.com.hk"
              method="POST"
              enctype="text/plain"
              @submit.prevent="handleFormSubmit"
            >
              <div class="form-row">
                <label class="form-label" for="contact-name">{{ t.contact.form.name }}</label>
                <input id="contact-name" name="Name" type="text" class="form-input" required />
              </div>
              <div class="form-row">
                <label class="form-label" for="contact-phone">{{ t.contact.form.phone }}</label>
                <input id="contact-phone" name="Phone" type="tel" class="form-input" required />
              </div>
              <div class="form-row">
                <label class="form-label" for="contact-email">{{ t.contact.form.email }}</label>
                <input id="contact-email" name="Email" type="email" class="form-input" required />
              </div>
              <div class="form-row">
                <label class="form-label" for="contact-message">{{ t.contact.form.message }}</label>
                <textarea
                  id="contact-message"
                  name="Message"
                  class="form-textarea"
                  rows="4"
                  required
                ></textarea>
              </div>
              <div class="contact-form-actions">
                <button type="submit" class="contact-button">{{ t.contact.form.send }}</button>
              </div>
            </form>
          </div>
        </div>

        <!-- Social Media Icons -->
        <div class="social-media-icons">
          <a href="https://www.instagram.com/vidalivinghk" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Instagram">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61585276086299" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="Facebook" @click="trackFacebookConversion">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="currentColor"/>
            </svg>
          </a>
          <a href="https://xhslink.com/m/8FaF6KC7WA1" target="_blank" rel="noopener noreferrer" class="social-icon" aria-label="XiaoHongShu" >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <rect x="2" y="2" width="20" height="20" rx="4" fill="#000000" />
            <!-- White Chinese characters "小红书" -->
            <text x="12" y="16" text-anchor="middle" font-size="6" fill="#FFFFFF" font-family="PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimHei, sans-serif" font-weight="900">
              小红书
            </text>
          </svg>
        </a>
        </div>
      </div>
    </section>

    <!-- Floating WhatsApp Button -->
    <a href="https://wa.me/85246342710" target="_blank" rel="noopener noreferrer" class="whatsapp-float" aria-label="WhatsApp">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="currentColor"/>
      </svg>
    </a>

    <!-- Image Dialog/Modal -->
    <div v-if="imageDialogOpen" class="image-dialog-overlay" @click="closeImageDialog">
      <div class="image-dialog-container" @click.stop>
        <button class="image-dialog-close" @click="closeImageDialog" aria-label="Close dialog">
          ×
        </button>
        <div class="image-dialog-content">
          <template v-if="currentImageSrc">
            <video
              v-if="isVideo(currentImageSrc)"
              :src="currentImageSrc"
              class="image-dialog-video"
              controls
              autoplay
              muted
              loop
              playsinline
              loading="lazy"
            ></video>
            <img
              v-else
              :src="currentImageSrc"
              :alt="`${currentImageSection} Image ${currentImageIndex + 1}`"
              class="image-dialog-img"
              loading="lazy"
            />
          </template>
          <div v-else class="image-dialog-placeholder">
            <span class="image-dialog-label">{{ currentImageSection.toUpperCase() }} - {{ t.dialog.image }} {{ currentImageIndex + 1 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import translations from '@/i18n/translations'

export default {
  name: 'App',
  data() {
    return {
      // Default language will be set in `mounted()` based on:
      // 1) saved `localStorage.language`
      // 2) device language (`navigator.language`)
      currentLanguage: 'en',
      mobileMenuOpen: false,
      productMenuExpanded: false,
      imageDialogOpen: false,
      currentImageSection: '',
      currentImageIndex: 0,
      useFullVideoLayout: true,
      landingPageTracked: false,
      languageDropdownOpen: false,
      contactObserver: null,
      videoSrc: require('@/assets/videos/bigPictureVid.mp4'),
      aboutUsBanner: require('@/assets/images/aboutus.webp'),
      finestMobileImage: require('@/assets/images/image587.webp'),
      designNestMobileImage: require('@/assets/images/image590.webp'),
      finestImage: require('@/assets/images/finest.webp'),
      vidaLogo: require('@/assets/images/VIDA-EUROPEAN-LIVING-300x203.webp'),
      headerLogo: require('@/../assets/cropped-cropped-Vida_master_logo_TAGLINE_CMYK_June25-1-e1758278529798.png'),
      // Banner images for each section
      kitchenBanner: require('@/assets/kitchen/vidakitchen.webp'),
      livingBanner: require('@/assets/living/VidaLiving.webp'),
      bedroomBanner: require('@/assets/bedroom/VidaBedroom.webp'),
      diningBanner: require('@/assets/dining/vidadining.webp'),
      // Image arrays for each section - add your image paths here
      kitchenImages: [
        require('@/assets/kitchen/kitchen1.webp'),
        require('@/assets/kitchen/kitchen2.webp'),
        require('@/assets/kitchen/kitchen3.webp'),
        require('@/assets/kitchen/kitchen4.webp'),
        require('@/assets/kitchen/kitchen5.webp'),
        require('@/assets/kitchen/kitchen6.webp'),
        null, // Add more images: require('@/assets/kitchen/kitchen2.png'),
        
        
        
        null
      ],
      livingImages: [
        require('@/assets/living/living1.webp'),
        require('@/assets/living/living2.webp'),
        require('@/assets/living/living3.webp'),
        require('@/assets/living/living4.webp'),
        require('@/assets/living/living5.webp'),
        require('@/assets/living/living6.webp'),
      ],
      diningImages: [
        require('@/assets/dining/dining1.webp'),
        require('@/assets/dining/dining2.webp'),
        require('@/assets/dining/dining3.webp'),
        require('@/assets/dining/dining4.webp'),
        require('@/assets/dining/dining5.webp'),
        require('@/assets/dining/dining6.webp'),
        null, // Add images: require('@/assets/dining/dining1.png'),
      ],
      bedroomImages: [
        require('@/assets/bedroom/bedroom1.webp'), 
        require('@/assets/bedroom/bedroom2.webp'), 
        require('@/assets/bedroom/bedroom3.webp'), 
        require('@/assets/bedroom/bedroom4.webp'), 
        require('@/assets/bedroom/bedroom5.webp'), 
        require('@/assets/bedroom/bedroom6.webp'), 
        null,
        null,
        null,
        null
      ],
      newsImages: [
        require('@/assets/news/new1-1.webp'), // Main big photo
        //require('@/assets/news/1-3.jpg'), // Gallery image 1
        //require('@/assets/news/2-3.jpg'), // Gallery image 2
        //require('@/assets/news/3-1.jpg') // Gallery image 3
        require('@/assets/news/news1.mp4'), // Gallery video 1
        require('@/assets/news/news2.mp4'), // Gallery video 2
        require('@/assets/news/news3.mp4') // Gallery video 3
      ],
      partnerLogos: [
        require('@/assets/partners/enorch.webp'),
        require('@/assets/partners/gaggenau.webp'),
        require('@/assets/partners/慕思.webp'),
        require('@/assets/partners/kiyoshiokada.webp'),
        require('@/assets/partners/namnam.webp')
      ],
      mapSources: {
        en: require('@/assets/Maps/Map_Eng.webp'),
        zh: require('@/assets/Maps/Map_繁.webp'),
        cn: require('@/assets/Maps/Map_簡.webp')
      }
    }
  },
  computed: {
    t() {
      return translations[this.currentLanguage] || translations.en
    },
    languageLabel() {
      if (this.currentLanguage === 'en') return 'EN'
      if (this.currentLanguage === 'zh') return '繁'
      if (this.currentLanguage === 'cn') return '简'
      return 'EN'
    },
    currentImageSrc() {
      if (!this.currentImageSection || this.currentImageIndex === undefined) {
        return null
      }
      const imageArray = this[`${this.currentImageSection}Images`]
      return imageArray && imageArray[this.currentImageIndex] ? imageArray[this.currentImageIndex] : null
    }
  },
  methods: {
    setupLanguageFromDevice() {
      const supported = ['en', 'zh', 'cn']

      // Prefer user choice saved in localStorage
      try {
        const saved = localStorage.getItem('language')
        if (saved && supported.includes(saved)) {
          this.currentLanguage = saved
          return
        }
      } catch (e) {
        // Ignore localStorage errors (e.g. private mode)
      }

      const candidates = []
      // Prefer navigator.languages (ordered list), fall back to navigator.language
      if (navigator.languages && navigator.languages.length) {
        candidates.push(...navigator.languages)
      }
      if (navigator.language) {
        candidates.push(navigator.language)
      }

      const deviceLang = (candidates[0] || 'en').toLowerCase()
      // Map device language to our app codes: en / zh(traditional) / cn(simplified)
      let detected = 'en'

      if (deviceLang.startsWith('zh')) {
        // Traditional hints
        if (
          deviceLang.includes('hant') ||
          deviceLang.includes('tw') ||
          deviceLang.includes('hk') ||
          deviceLang.includes('mo')
        ) {
          detected = 'zh'
        } else if (
          // Simplified hints
          deviceLang.includes('hans') ||
          deviceLang.includes('cn') ||
          deviceLang.includes('sg')
        ) {
          detected = 'cn'
        } else {
          // Generic "zh" without script/region usually defaults to Simplified
          detected = 'cn'
        }
      } else if (deviceLang.startsWith('en')) {
        detected = 'en'
      }

      this.currentLanguage = supported.includes(detected) ? detected : 'en'
    },
    isVideo(media) {
      return typeof media === 'string' && media.toLowerCase().endsWith('.mp4')
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      if (this.mobileMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      document.body.style.overflow = ''
    },
    toggleProductMenu() {
      this.productMenuExpanded = !this.productMenuExpanded
    },
    smoothScrollTo(target) {
      const element = document.querySelector(target)
      if (element) {
        const headerOffset = 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    },
    handleNavClick(event, target) {
      event.preventDefault()
      this.smoothScrollTo(target)
      this.closeMobileMenu()
    },
    updateVideoLayoutMode() {
      // Keep full video on desktop; use compact 16:9 on mobile/tablet
      this.useFullVideoLayout = window.innerWidth > 768
    },
    openImageDialog(section, index) {
      this.currentImageSection = section
      this.currentImageIndex = index
      this.imageDialogOpen = true
      document.body.style.overflow = 'hidden'
    },
    closeImageDialog() {
      this.imageDialogOpen = false
      document.body.style.overflow = ''
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.imageDialogOpen) {
        this.closeImageDialog()
      }
    },
    changeLanguage(lang) {
      this.currentLanguage = lang
      localStorage.setItem('language', lang)
    },
    toggleLanguageDropdown() {
      this.languageDropdownOpen = !this.languageDropdownOpen
    },
    closeLanguageDropdown() {
      this.languageDropdownOpen = false
    },
    handleLanguageSelect(lang) {
      this.changeLanguage(lang)
      this.closeLanguageDropdown()
    },
    handleGlobalClick(event) {
      const switcher = this.$refs.languageSwitcher
      if (!switcher) return
      if (!switcher.contains(event.target)) {
        this.closeLanguageDropdown()
      }
    },
    trackFacebookConversion() {
      // Appier Web Tracking Code - Tag #3: Track Conversion_fb_button
      window.appier_q = window.appier_q || [];
      window.appier_q.push(
        {"t": "register", "content": { "id": "3906", "site": "vidaliving.com.hk" }},
        {"t": "type_conversion", "content": "submit", "action_id": "Conversion_60e5", "track_id": "61e4a1890d8e61a", "opts": {"unique_key": "true"}}
      );
    },
    handleFormSubmit(event) {
      // Appier Web Tracking Code - Tag #3: Track Conversion tag (Form Submit)
      window.appier_q = window.appier_q || [];
      window.appier_q.push(
        {"t": "register", "content": { "id": "3906", "site": "vidaliving.com.hk" }},
        {"t": "type_conversion", "content": "submit", "action_id": "Conversion_60e5", "track_id": "61e4a1890d8e61a", "opts": {"unique_key": "true"}}
      );
      
      // Allow form to submit normally after tracking
      // The form will use mailto: action
      return true;
    },
    trackLandingPage() {
      // Appier Web Tracking Code - Tag #2: Track Landing Page Tag
      // This will be called when contact section becomes visible
      window.appier_q = window.appier_q || [];
      window.appier_q.push(
        {"t": "register", "content": { "id": "3906", "site": "vidaliving.com.hk" }},
        {"t": "type_landing", "action_id": "ViewLanding_4eb0", "track_id": "61e4a1890d8e61a", "opts": {"unique_key": "true"}}
      );
    },
    setupContactSectionObserver() {
      // Use Intersection Observer to detect when contact section becomes visible
      if (!this.$refs.contactSection) return;
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.landingPageTracked) {
            // Contact section is visible, trigger landing page tracking
            this.trackLandingPage();
            this.landingPageTracked = true;
            // Disconnect observer after tracking to prevent duplicate events
            observer.disconnect();
          }
        });
      }, {
        threshold: 0.3 // Trigger when 30% of section is visible
      });
      
      observer.observe(this.$refs.contactSection);
      // Store observer reference for cleanup
      this.contactObserver = observer;
    }
  },
  mounted() {
    this.setupLanguageFromDevice()
    window.addEventListener('keydown', this.handleEscapeKey)
    window.addEventListener('resize', this.updateVideoLayoutMode)
    window.addEventListener('click', this.handleGlobalClick)
    this.updateVideoLayoutMode()
    // Setup contact section observer for landing page tracking (Tag #2)
    this.$nextTick(() => {
      this.setupContactSectionObserver()
    })
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEscapeKey)
    window.removeEventListener('resize', this.updateVideoLayoutMode)
    window.removeEventListener('click', this.handleGlobalClick)
    // Clean up observer
    if (this.contactObserver) {
      this.contactObserver.disconnect()
    }
  }
}
</script>

<style scoped>
/* Header Styles */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #F5F1EB;
  padding: 1rem 2rem;
  transition: all 0.3s ease;
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 48px;
  width: auto;
  display: block;
}

.logo-text {
  margin-left: 0.75rem;
  font-size: 1rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-family: 'Ubuntu', sans-serif;
  color: #1a1a1a;
  white-space: nowrap;
}

/* Header Right Section */
.header-right-section {
  display: flex;
  align-items: center;
  gap: 2rem;
}

/* Desktop Navigation */
.desktop-nav {
  display: flex;
  gap: 2rem;
}

.nav-link {
  text-decoration: none;
  color: #1a1a1a;
  font-size: 0.9rem;
  font-weight: 400;
  letter-spacing: 1px;
  transition: color 0.3s ease;
  font-family: 'Ubuntu', sans-serif;
}

.nav-link:hover {
  color: #666;
}

/* Language Switcher */
.language-switcher {
  position: relative;
  display: flex;
  align-items: center;
}

.lang-current-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: none;
  color: #1a1a1a;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-family: 'Ubuntu', sans-serif;
}

.lang-current-btn:hover {
  color: #666;
}

.lang-current-icon {
  font-size: 0.7rem;
  transition: transform 0.2s ease;
}

.lang-current-icon.open {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  right: 0;
  top: 120%;
  min-width: 80px;
  padding: 0.25rem 0;
  margin: 0;
  list-style: none;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
  z-index: 1500;
}

.lang-dropdown-item {
  width: 100%;
  text-align: left;
  padding: 0.4rem 0.75rem;
  background: none;
  border: none;
  color: #1a1a1a;
  font-size: 0.85rem;
  font-family: 'Ubuntu', sans-serif;
  cursor: pointer;
}

.lang-dropdown-item:hover {
  background-color: #f5f1eb;
}

.lang-dropdown-item.active,
.lang-dropdown-item.current {
  font-weight: 700;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.mobile-language-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 0;
  margin-top: 0.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/* Header Actions Container */
.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Hamburger Button */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  gap: 4px;
}

.hamburger-btn span {
  width: 24px;
  height: 2px;
  background-color: #1a1a1a;
  transition: all 0.3s ease;
}

.hamburger-btn.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-btn.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-btn.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

/* Menu Overlay */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1999;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* Right Side Sliding Menu */
.side-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 320px;
  max-width: 85vw;
  height: 100vh;
  background-color: #F5F1EB;
  z-index: 2000;
  transition: right 0.3s ease;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  overflow-y: auto;
}

.side-menu.open {
  right: 0;
}

.side-menu-content {
  display: flex;
  flex-direction: column;
  padding: 5rem 2rem 2rem;
  height: 100%;
}

.side-menu-link {
  text-decoration: none;
  color: #1a1a1a;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 1px;
  padding: 1rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: color 0.3s ease;
  font-family: 'Ubuntu', sans-serif;
}

.side-menu-link:hover {
  color: #666;
}

/* Expandable Product Menu */
.side-menu-expandable {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.side-menu-expandable-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  color: #1a1a1a;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 1px;
  padding: 1rem 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Ubuntu', sans-serif;
  transition: color 0.3s ease;
}

.side-menu-expandable-header:hover {
  color: #666;
}

.expandable-arrow {
  font-size: 1.5rem;
  line-height: 1;
  transition: transform 0.3s ease;
  color: #1a1a1a;
}

.expandable-arrow.expanded {
  transform: rotate(90deg);
}

.side-menu-submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  display: flex;
  flex-direction: column;
}

.side-menu-submenu.expanded {
  max-height: 500px;
}

.side-menu-sublink {
  padding-left: 1.5rem;
  font-size: 0.9rem;
  display: block;
  width: 100%;
}

.side-menu-language-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem 0 1rem;
  margin-top: auto;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/* Wardrobe Section */
.wardrobe-section {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-top: 70px;
}

.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.video-background.video-background-compact {
  position: relative;
  top: auto;
  left: auto;
  height: auto;
  padding-top: 56.25%;
  max-width: 1200px;
  margin: 0 auto;
  /*border-radius: 14px;*/
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
}

.background-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.background-video.background-video-compact {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.video-overlay.video-overlay-compact {
  /*border-radius: 14px;*/
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.35) 100%);
}

.wardrobe-section.video-theme-compact {
  min-height: auto;
  padding: 130px 1.25rem 2rem;
  display: block;
}

@media (max-width: 768px) {
  .wardrobe-section.video-theme-compact {
    padding: 0;
  }

  .video-background.video-background-compact {
    padding-top: 56.25%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .video-background.video-background-compact {
    padding-top: 56.25%;
    max-width: 100%;
  }
}

.wardrobe-content {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 1400px;
  padding: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 80vh;
}

.wardrobe-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  flex: 1;
  max-width: 80%;
}

.wardrobe-item {
  position: relative;
  aspect-ratio: 4 / 3;
}

.wardrobe-placeholder {
  width: 100%;
  height: 100%;
  background-color: #888;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(100%);
}

.placeholder-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  text-align: center;
}

.bespoke-text {
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: white;
  font-size: 1.5rem;
  font-weight: 300;
  letter-spacing: 4px;
  text-align: right;
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.bespoke-line {
  display: block;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .header {
    padding: 1rem;
  }

  .desktop-nav {
    display: none;
  }

  .language-switcher {
    display: flex;
  }

  .header-right-section {
    gap: 0;
  }

  .header-actions {
    gap: 0.4rem;
  }

  .lang-current-btn {
    padding: 0.25rem 0.35rem;
  }

  .wardrobe-content {
    flex-direction: column;
    padding: 1rem;
    min-height: auto;
  }

  .wardrobe-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    max-width: 100%;
    width: 100%;
  }

  .bespoke-text {
    position: static;
    transform: none;
    margin-top: 1rem;
    text-align: center;
    font-size: 1rem;
    writing-mode: horizontal-tb;
    letter-spacing: 2px;
  }
}

@media (max-width: 480px) {
  .logo-image {
    height: 36px;
  }

  .bespoke-text {
    font-size: 0.9rem;
    letter-spacing: 2px;
  }
}

/* Kitchen Section */
.kitchen-section {
  width: 100%;
}

.kitchen-banner {
  position: relative;
  width: 100%;
  min-height: 60vh;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  background-image: 
    repeating-linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.03) 0px,
      transparent 1px,
      transparent 2px,
      rgba(255, 255, 255, 0.03) 3px
    );
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.section-banner-image {
  width: 100%;
  height: 100%;
  min-height: 60vh;
  object-fit: cover;
  display: block;
}

.kitchen-banner-content {
  position: relative;
  text-align: center;
  z-index: 2;
}

.kitchen-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}

.vida-text {
  font-size: 3.5rem;
  font-weight: 300;
  letter-spacing: 8px;
  color: white;
  text-transform: uppercase;
  font-family: 'Ubuntu', sans-serif;
  position: relative;
}

.vida-text::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
}

.kitchen-text {
  font-size: 4.5rem;
  font-weight: 600;
  letter-spacing: 6px;
  color: white;
  text-transform: uppercase;
  font-family: 'Ubuntu', sans-serif;
}

/* Kitchen Grid Section */
.kitchen-grid-section {
  width: 100%;
  background-color: #F5F1EB;
  padding: 4rem 2rem;
  position: relative;
}

.kitchen-grid-section::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 100%;
  background: 
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.kitchen-grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.kitchen-grid-item {
  position: relative;
  aspect-ratio: 1;
  width: 100%;
}

.kitchen-image,
.kitchen-image-placeholder {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.kitchen-image-placeholder {
  background-color: #888;
  filter: grayscale(100%);
}

.kitchen-grid-item {
  cursor: pointer;
}

.kitchen-image:hover,
.kitchen-image-placeholder:hover {
  transform: scale(1.02);
}

.kitchen-image-placeholder:hover {
  filter: grayscale(80%);
}

/* Kitchen Section Responsive */
@media (max-width: 768px) {
  .kitchen-banner {
    min-height: 50vh;
    padding: 0;
  }

  .section-banner-image {
    min-height: 50vh;
  }

  .vida-text {
    font-size: 2.5rem;
    letter-spacing: 6px;
  }

  .kitchen-text {
    font-size: 3rem;
    letter-spacing: 4px;
  }

  .kitchen-grid-section {
    padding: 3rem 1.5rem;
  }

  .kitchen-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .kitchen-banner {
    min-height: 40vh;
    padding: 0;
  }

  .section-banner-image {
    min-height: 40vh;
  }

  .vida-text {
    font-size: 2rem;
    letter-spacing: 4px;
  }

  .kitchen-text {
    font-size: 2.5rem;
    letter-spacing: 3px;
  }

  .kitchen-grid-section {
    padding: 2rem 1rem;
  }

  .kitchen-grid {
    gap: 1rem;
  }
}

/* About Us Section */
.about-section {
  width: 100%;
  background-color: #F5F1EB;
}

/* About Us Banner */
.about-banner {
  width: 100%;
  padding: 4rem 2rem;
  background-color: #F5F1EB;
}

.about-banner-container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.about-us-title {
  display: flex;
  flex-direction: column;
  font-size: 4rem;
  font-weight: 600;
  color: #2d2d2d;
  letter-spacing: 2px;
  line-height: 1.1;
}

.about-us-title .space {
  height: 0.5rem;
}

/* Storefront Image Banner */
.storefront-banner {
  width: 100%;
  padding: 0 2rem;
  background-color: #F5F1EB;
}

.storefront-banner-container {
  max-width: 1400px;
  margin: 0 auto;
}

.storefront-image {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* About Content */
.about-content {
  width: 100%;
  padding: 2rem 2rem;
  background-color: #F5F1EB;
  position: relative;
}

.about-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 40%;
  height: 100%;
  background: 
    radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.15) 0%, transparent 60%),
    radial-gradient(circle at 70% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.about-content-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(260px, 35%) 1fr;
  gap: 4rem;
  position: relative;
  z-index: 1;
}

.about-section-a .about-content-container {
  display: grid;
  grid-template-columns: minmax(220px, 32%) 1fr;
  gap: 16rem;
  align-items: flex-start;
  padding: 0 2rem;
}

/* Left Side: Branding */
.about-logo-column {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2rem;
}

.vida-logo-image {
  width: 100%;
  max-width: 300px;
  height: auto;
  display: block;
  position: relative;
  z-index: 1;
}

.vida-logo-large {
  font-size: 6rem;
  font-weight: 600;
  color: #2d2d2d;
  letter-spacing: 4px;
  margin: 0;
  line-height: 1;
  font-family: 'Ubuntu', sans-serif;
}

.european-living {
  font-size: 1.2rem;
  font-weight: 400;
  color: #2d2d2d;
  letter-spacing: 3px;
  margin-top: 1rem;
  text-transform: uppercase;
}

/* Right Side: Content */
.about-text-column {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.about-paragraph-block {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.about-paragraph {
  font-size: 18px;
  line-height: 1.6;
  color: #2d2d2d;
  margin: 0;
  text-align: left;
}
.about-text-column.align-right {
  align-items: flex-end;
}
.about-text-column.align-right .about-paragraph {
  text-align: left;
}
.about-section-a .about-text-column.align-right {
  align-items: flex-start;
}
.about-section-a .about-text-column.align-right .about-paragraph {
  text-align: left;
}

.section-heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d2d2d;
  letter-spacing: 1px;
  margin: 0;
  text-transform: uppercase;
}

/* Timeline Graphics */
.timeline-graphics {
  display: flex;
  justify-content: flex-end;
  max-width:85%;
  padding: 2rem 2rem 0;
}

.finest-image {
  width: 100%;
  max-width: 940px;
  height: auto;
  display: block;
}

/* Mobile About Images */
.about-mobile-images {
  display: none;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  padding: 2rem 2rem;
  background-color: #F5F1EB;
}

.about-mobile-image-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.about-mobile-image-wrapper {
  width: 100%;
}

.about-mobile-image-placeholder {
  width: 100%;
  aspect-ratio: 4 / 3;
  background-color: #888;
  border-radius: 4px;
  filter: grayscale(100%);
}
.about-mobile-image {
  width: 100%;
  height: auto;
  max-height: 120px;
  border-radius: 4px;
  display: block;
  object-fit: cover;
}

.about-mobile-caption {
  font-size: 0.9rem;
  color: #2d2d2d;
  margin: 0;
  text-align: center;
  font-family: 'Ubuntu', sans-serif;
  line-height: 1.5;
}

.about-mobile-paragraphs {
  grid-column: 1 / -1;
  display: none;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
}

.timeline-badge {
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.finest-badge {
  background-color: #6b7d6b;
}

.nest-badge {
  background-color: #5a7a9a;
}

.nest-icon {
  font-size: 1rem;
}

.contact-section {
  width: 100%;
  background-color: #F5F1EB;
  padding: 4rem 2rem 5rem;
}

.contact-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(320px, 42%) 1fr;
  gap: 2.5rem;
  align-items: center;
}

.contact-map {
  width: 100%;
  background: #eee;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  min-height: 320px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
}

.map-link {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

.map-placeholder {
  flex: 1;
  background: linear-gradient(135deg, #f7f1e9 0%, #e7ded1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a7a62;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.contact-card {
  display: grid;
  grid-template-columns: 8px 1fr;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.contact-accent {
  background: linear-gradient(180deg, #cda676 0%, #b78d53 100%);
}

.contact-details {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-title {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
  font-size: 1.4rem;
  letter-spacing: 1px;
}

.contact-title-bold {
  font-weight: 800;
  color: #1a1a1a;
}

.contact-title-light {
  font-weight: 400;
  color: #2d2d2d;
}

.contact-heading {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
}

.contact-text {
  margin: 0.15rem 0 0;
  font-size: 0.98rem;
  line-height: 1.7;
  color: #2d2d2d;
}

.contact-info-grid {
  display: grid;
  grid-template-columns: max-content 1fr;
  column-gap: 1rem;
  align-items: baseline;
}

.contact-info-grid strong {
  white-space: nowrap;
}

.contact-link {
  color: #1a1a1a;
  font-weight: 700;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}

.contact-block {
  margin-top: 0.35rem;
}

.contact-form-card {
  align-self: stretch;
  background: white;
  grid-column: 1 / -1;
}

.contact-form {
  display: grid;
  gap: 1rem;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.form-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1a1a1a;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.75rem 0.85rem;
  border: 1px solid #d7d1c7;
  border-radius: 6px;
  background: #fdfbf7;
  font-size: 0.98rem;
  color: #1a1a1a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #cda676;
  box-shadow: 0 0 0 3px rgba(205, 166, 118, 0.2);
}

.form-textarea {
  resize: vertical;
  min-height: 140px;
}

.contact-form-actions {
  display: flex;
  justify-content: flex-start;
}

.contact-button {
  border: none;
  background: linear-gradient(135deg, #cda676 0%, #b78d53 100%);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}

.contact-button:hover {
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.contact-button:active {
  transform: translateY(0);
}

/* Social Media Icons */
.social-media-icons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  padding-top: 2rem;
  width: 100%;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: #1a1a1a;
  transition: all 0.3s ease;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);
}

.social-icon:hover {
  color: #666;
  background-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Floating WhatsApp Button */
.whatsapp-float {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 60px;
  height: 60px;
  background-color: #956c35;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px #2c2303;
  z-index: 1000;
  transition: all 0.3s ease;
  color: #f6f1eb;
}

.whatsapp-float:hover {
  background-color: #956c35;
  box-shadow: 0 6px 16px #2c2303;
  transform: scale(1.1);
}

.whatsapp-float svg {
  width: 32px;
  height: 32px;
}

/* Showroom Section */
.showroom-section {
  width: 100%;
  background-color: #3a3a3a;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  color: #f4f4f4;
}

.showroom-image,
.showroom-image-placeholder {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.showroom-hero {
  position: relative;
  width: 100%;
  margin: 0 auto;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  border-radius: 6px;
  background: #3a3a3a;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}

.showroom-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background-color: #3a3a3a;
}

.showroom-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0.35) 100%);

}

.showroom-hero-title {
  font-size: 2.6rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: center;
}

.showroom-intro {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  color: #e6e6e6;
  line-height: 1.6;
  font-size: 1rem;
}

.showroom-feature-card {
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.5rem;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
  /*height: clamp(260px, 34vw, 420px);*/
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
}

.showroom-feature-card > * {
  height: 100%;
  min-width: 0;
}

.showroom-feature-image {
  position: relative;
  height: 100%;
  background: #777;
  border-radius: 4px;
  overflow: hidden;
  min-width: 0;
}

.showroom-feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #777;
}

.showroom-feature-text {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  justify-content: center;
  height: 100%;
  min-width: 0;
}

.showroom-feature-text h3 {
  margin: 0;
  font-size: 1.25rem;
  letter-spacing: 1px;
  line-height: 1.4;
}

.showroom-feature-text p {
  margin: 0;
  line-height: 1.5;
  color: #e0e0e0;
}

.showroom-read-more {
  color: #d7b175;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 0.9rem;
}

.showroom-read-more:hover {
  text-decoration: underline;
}

.showroom-gallery {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 1rem;
}

.showroom-gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
}

.showroom-gallery-item {
  position: relative;
  aspect-ratio: 1;
  background: #777;
  border-radius: 4px;
  overflow: hidden;
}

.showroom-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #777;
}

.partners-section {
  width: 100%;
  background-color: #f4e9dd;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.partners-intro {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  color: #3c3c3c;
  line-height: 1.6;
  font-size: 0.95rem;
  padding: 0 1.5rem;
}

.partners-hero {
  position: relative;
  width: 100%;
  margin: 0 auto;
  aspect-ratio: 3 / 1;
  overflow: hidden;
  border-radius: 6px;
  background: #ccc;
}

.partners-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #ccc;
}

.partners-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.35) 100%);
}

.partners-hero-title {
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: 3px;
  color: #fff;
}

.partners-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.partner-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.partner-logo {
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.partner-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.partner-text {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.partner-title {
  margin: 0;
  font-weight: 700;
  color: #2d2d2d;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.partner-body {
  margin: 0;
  color: #4a4a4a;
  line-height: 1.6;
  font-size: 0.95rem;
}

.partner-separator {
  height: 4px;
  width: 120px;
  background: #1a1a1a;
  border-radius: 4px;
  align-self: center;
}

@media (max-width: 768px) {
  .partners-section {
    padding: 0 1rem 3rem;
    gap: 1.5rem;
  }

  .partners-hero {
    aspect-ratio: 16 / 9;
  }

  .partners-hero-title {
    font-size: 1.8rem;
    letter-spacing: 2px;
  }

  .partners-intro {
    padding: 0 1rem;
  }

  .partners-content {
    padding: 1.5rem 1.25rem;
  }

  .partner-logo {
    min-height: 180px;
  }
}

@media (max-width: 480px) {
  .partners-section {
    padding: 0 0.75rem 2.5rem;
  }

  .partners-hero-title {
    font-size: 1.5rem;
    letter-spacing: 1.5px;
  }

  .partners-content {
    padding: 1.25rem 1rem;
  }

  .partner-logo {
    min-height: 160px;
  }
}

@media (max-width: 1024px) {
  .showroom-hero-title {
    font-size: 2.2rem;
  }

  .showroom-feature-card {
    grid-template-columns: 1fr;
  }

  .showroom-gallery-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {


  .showroom-hero {
    aspect-ratio: 16 / 9;
  }

  .showroom-hero-title {
    font-size: 2rem;
  }

  .showroom-feature-card {
    grid-template-columns: 1fr;
    height: auto;
    gap: 1rem;
    padding: 1rem;
  }

  .showroom-feature-card > * {
    height: auto;
  }

  .showroom-feature-card .showroom-feature-image:not(:first-child) {
    display: none;
  }

  .showroom-feature-image {
    height: auto;
  }

  .showroom-feature-image img {
    width: 100%;
    height: auto;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    display: block;
  }

  .showroom-feature-text {
    padding: 1rem;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .showroom-gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .showroom-section {
    padding: 0 0.75rem 2rem;
    gap: 1.5rem;
  }

  .showroom-hero-title {
    font-size: 1.6rem;
    letter-spacing: 2px;
  }

  .showroom-intro {
    font-size: 0.95rem;
  }

  .showroom-gallery-grid {
    gap: 0.75rem;
  }
}

/* News Section */
.news-section {
  width: 100%;
  background-color: #F5F1EB;
  padding: 4rem 2rem;
}

.news-container {
  max-width: 1400px;
  margin: 0 auto;
}

.news-title {
  font-size: 3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 3rem;
  font-family: 'Ubuntu', sans-serif;
  letter-spacing: 2px;
}

.news-main-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-bottom: 3rem;
  align-items: start;
}

.news-main-image {
  width: 100%;
  cursor: pointer;
}

.news-image,
.news-image-placeholder {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: 4px;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.news-image-placeholder {
  background-color: #888;
  filter: grayscale(100%);
}

.news-main-image:hover .news-image,
.news-main-image:hover .news-image-placeholder {
  transform: scale(1.02);
}

.news-image-placeholder:hover {
  filter: grayscale(80%);
}

.news-text-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.news-headline {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d2d2d;
  line-height: 1.4;
  font-family: 'Ubuntu', sans-serif;
}

.news-paragraph {
  font-size: 18px;
  line-height: 1.6;
  color: #2d2d2d;
  margin: 0;
  font-family: 'Ubuntu', sans-serif;
}

.exhibition-details {
  margin-top: 1rem;
}

.exhibition-details-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 1rem;
  font-family: 'Ubuntu', sans-serif;
}

.exhibition-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.exhibition-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.exhibition-label {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 1rem;
  font-family: 'Ubuntu', sans-serif;
}

.exhibition-value {
  color: #2d2d2d;
  font-size: 1rem;
  font-family: 'Ubuntu', sans-serif;
}

.exhibition-dates {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.exhibition-dates div {
  color: #2d2d2d;
  font-size: 1rem;
  font-family: 'Ubuntu', sans-serif;
}

.news-gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.news-gallery-item {
  width: 100%;
  cursor: pointer;
}

.news-gallery-item .news-image,
.news-gallery-item .news-image-placeholder {
  aspect-ratio: 1;
}

.news-gallery-item:hover .news-image,
.news-gallery-item:hover .news-image-placeholder {
  transform: scale(1.02);
}

.about-split {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(220px, 32%) 1fr;
  gap: 16rem;
  padding: 2rem 2rem 4rem;
  align-items: flex-start;
}

/* Partner Logo */
.partner-logo {
  margin-top: 1rem;
}

.gaggenau-logo {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 2px;
}

/* News Section Responsive */
@media (max-width: 1024px) {
  .news-main-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .news-gallery {
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .news-section {
    padding: 3rem 1.5rem;
  }

  .news-title {
    font-size: 2.5rem;
    margin-bottom: 2rem;
  }

  .news-headline {
    font-size: 1.3rem;
  }

  .news-paragraph {
    font-size: 16px;
  }

  .news-gallery {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 480px) {
  .news-section {
    padding: 2rem 1rem;
  }

  .news-title {
    font-size: 2rem;
  }

  .news-headline {
    font-size: 1.1rem;
  }

  .news-paragraph {
    font-size: 15px;
  }
}

/* About Section Responsive */
@media (max-width: 1024px) {
  .about-content-container {
    grid-template-columns: 1fr;
    gap: 15rem;
  }

  .vida-logo-image {
    max-width: 250px;
  }

  .vida-logo-large {
    font-size: 4.5rem;
  }

  .about-split {
    grid-template-columns: 1fr;
    padding: 2rem 1.5rem 3rem;
  }

  .about-text-column.align-right {
    align-items: flex-start;
  }

  .about-text-column.align-right .about-paragraph {
    text-align: left;
  }

  .about-section-a .about-content-container {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .contact-container {
    grid-template-columns: 1fr;
  }

  .contact-map {
    min-height: 240px;
  }
}

@media (max-width: 768px) {
  .about-banner {
    padding: 3rem 1.5rem;
  }

  .about-banner-container {
    justify-content: center;
  }

  .about-us-title {
    font-size: 3rem;
  }

  .storefront-image {
    max-width: 100%;
  }

  .about-content {
    padding: 3rem 1.5rem;
  }

  .vida-logo-large {
    font-size: 3.5rem;
  }

  .european-living {
    font-size: 1rem;
  }

  .timeline-graphics {
    display: none;
  }

  .about-mobile-images {
    display: grid;
    padding: 2rem 1.5rem;
    gap: 1rem;
  }

  .about-mobile-paragraphs {
    display: flex;
    padding: 2rem 1.5rem;
  }

  .about-split {
    display: none;
  }

  .vida-logo-image {
    display: none;
  }

  .about-logo-column {
    display: none;
  }

  .about-content {
    padding-top: 0;
    padding-bottom: 0;
  }

  .about-text-column {
    padding-top: 0;
    padding-bottom: 0;
  }

  .about-paragraph-block {
    padding-top: 0;
    padding-bottom: 0;
  }

  .about-paragraph {
    margin-top: 0;
    margin-bottom: 0;
  }
}

@media (max-width: 480px) {
  .about-banner {
    padding: 2rem 1rem;
  }

  .about-us-title {
    font-size: 2.5rem;
  }

  .storefront-image {
    max-width: 100%;
  }

  .vida-logo-image {
    max-width: 200px;
  }

  .finest-image {
    max-width: 100%;
  }

  .about-content {
    padding: 2rem 1rem;
  }

  .vida-logo-large {
    font-size: 3rem;
  }

  .about-paragraph {
    font-size: 0.9rem;
  }

  .section-heading {
    font-size: 1.2rem;
  }
}

/* Image Dialog/Modal Styles */
.image-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.image-dialog-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.3s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.image-dialog-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 2rem;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 2001;
  line-height: 1;
  padding: 0;
}

.image-dialog-close:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: rotate(90deg);
}

.image-dialog-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-dialog-img,
.image-dialog-video {
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.image-dialog-video {
  background-color: #000;
}

.image-dialog-placeholder {
  width: 100%;
  max-width: 1200px;
  aspect-ratio: 1;
  background-color: #555;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: grayscale(0%);
  border: 2px solid rgba(255, 255, 255, 0.2);
  position: relative;
}

.image-dialog-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: 2px;
  text-transform: uppercase;
}

/* Responsive Dialog Styles */
@media (max-width: 768px) {
  .image-dialog-overlay {
    padding: 1rem;
  }

  .image-dialog-close {
    top: 0.5rem;
    right: 0.5rem;
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }

  .image-dialog-label {
    font-size: 1.2rem;
  }
}

@media (max-width: 480px) {
  .image-dialog-overlay {
    padding: 0.5rem;
  }

  .image-dialog-close {
    top: 0.25rem;
    right: 0.25rem;
    width: 36px;
    height: 36px;
    font-size: 1.25rem;
  }

  .image-dialog-label {
    font-size: 1rem;
  }

  .whatsapp-float {
    bottom: 1rem;
    right: 1rem;
    width: 56px;
    height: 56px;
  }

  .whatsapp-float svg {
    width: 28px;
    height: 28px;
  }
}
</style>
